import React, { useState } from "react";
import GroomingSelfiesList from "../../components/GroomingSelfies/GroomingSelfiesList";
import GroomingSelfiesModal from "../../components/GroomingSelfies/GroomingSelfiesModal";
import { useLocation } from "react-router-dom";
import FilterButton from "../../components/Common/FilterButton";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as GroomingSelfiesActions from "../../store/actions/GroomingSelfies";

const GroomingSelfies = ({ groomingSelfiesList, activeFilters, getGroomingSelfiesList }) => {
  const [modalState, setModalState] = useState("");
  const [displayedSelfiesFromQueryParams, setDisplayedSelfiesFromQueryParams] = useState(false);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const filterFields = [
    "driver_id",
    "selfie_type",
    "ref_trip_id",
    "start_date",
    "end_date",
  ];
  const handleClick = (type) => {
    setModalState(type);
  };

  const handleClose = () => {
    setModalState("");
  };

  const handleQueryParamsDisplay = () => {
    setDisplayedSelfiesFromQueryParams(true);
  }

  const driverId = queryParams.get("driver_id");
  const selfie_type = queryParams.get("selfie_type");
  const refTripId = queryParams.get("ref_trip_id");
  if(!displayedSelfiesFromQueryParams && driverId && selfie_type && refTripId) {
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 1);
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 60);
    const filters = {
      driver_id: driverId,
      selfie_type: selfie_type,
      ref_trip_id: refTripId,
      start_date: startDate.toISOString().substring(0, 10),
      end_date: endDate.toISOString().substring(0, 10),
    };
    getGroomingSelfiesList(filters).then((_) => {
      handleQueryParamsDisplay();
    });
  }
  
  return (
    <div className="Grooming-Selfies-View">
      <div
        style={{ maxWidth: "320px" }}
        className="actionBar mb-20 flex items-end justify-end"
      >
        <FilterButton
          activeFilters={activeFilters}
          handleClick={() => handleClick("Filter")}
        />
      </div>
      <GroomingSelfiesList groomingSelfiesList={groomingSelfiesList} />
      {modalState && (
        <GroomingSelfiesModal
          modalState={modalState}
          handleClose={handleClose}
          filterFields={filterFields}
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const { GroomingSelfies } = state;
  return {
    groomingSelfiesList: GroomingSelfies.groomingSelfiesList,
    activeFilters: GroomingSelfies.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getGroomingSelfiesList: bindActionCreators(
      GroomingSelfiesActions.getGroomingSelfiesList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroomingSelfies);
